import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { ace_api } from '@axo/shared/data-access/api';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { notificationKeys } from '@axo/shared/data-access/hooks';

export function useUnreadNotification() {
  const { state } = useContext(DataAccessContext);
  const client = useQueryClient();
  const api = useAPI();

  return useMutation(
    ({ id }: { id: number; marketCountry: string }) =>
      ace_api.unreadNotification(api)(id),
    {
      onSuccess: (_, { marketCountry }) =>
        Promise.all([
          client.invalidateQueries(
            notificationKeys.root({
              user: state.user.clientID,
              country: marketCountry,
            }),
          ),
        ]),
    },
  );
}
